import { Grid } from '@mantine/core';
import { useSelector } from 'react-redux';
import HeaderStatistic from '../../HeaderStatistic';
import LazyLoadSpinner from '../../LazyLoaderSpinner';
const GoogleAdStats = ({ stats, googleAd }) => {
  const googleAccount = useSelector((state) => state.google.account);

  const id = googleAd?.id;
  const adAccountCurrency = googleAccount?.adAccountCurrency;

  let statsElement;
  if (!stats) {
    statsElement = (
      <Grid.Col span={12}>
        <Grid justify="center">
          <LazyLoadSpinner />
        </Grid>
      </Grid.Col>
    );
  } else {
    statsElement = (
      <Grid.Col span={12}>
        <Grid>
          <Grid.Col span="auto" ta="center">
            <HeaderStatistic title="Impressions" stats={stats} stat="sent" id={id} statKey="count" />
          </Grid.Col>

          <Grid.Col span="auto" ta="center">
            <HeaderStatistic title="Clicks" stats={stats} stat="clicks" id={id} statKey="count" />
          </Grid.Col>
          <Grid.Col span="auto" ta="center">
            <HeaderStatistic title="Conversions" stats={stats} stat="conversions" id={id} statKey="count" />
          </Grid.Col>
          <Grid.Col span="auto" ta="center">
            <HeaderStatistic
              title="Conversions Value"
              stats={stats}
              stat="conversions"
              id={id}
              statKey="value"
              currency={adAccountCurrency}
            />
          </Grid.Col>
          <Grid.Col span="auto" ta="center" style={{ borderLeft: '1px dotted' }}>
            <HeaderStatistic title="Interactions" stats={stats} stat="interactions" id={id} statKey="count" />
          </Grid.Col>
          <Grid.Col span="auto" ta="center">
            <HeaderStatistic title="Engagements" stats={stats} stat="engagements" id={id} statKey="count" />
          </Grid.Col>
          <Grid.Col span="auto" ta="center">
            <HeaderStatistic
              title="CTR"
              stats={stats}
              stat="clickThroughRate"
              id={id}
              statKey="value"
              showPercentageSign={true}
            />
          </Grid.Col>
          <Grid.Col span="auto" ta="center" style={{ borderLeft: '1px dotted' }}>
            <HeaderStatistic title="Bounce Rate" stats={stats} id={id} statKey="value" showPercentageSign={true} />
          </Grid.Col>
          <Grid.Col span="auto" ta="center" style={{ borderLeft: '1px dotted' }}>
            <HeaderStatistic
              title="Spend"
              stats={stats}
              stat="spend"
              id={id}
              statKey="value"
              currency={adAccountCurrency}
            />
          </Grid.Col>
        </Grid>
      </Grid.Col>
    );
  }
  return statsElement;
};

export default GoogleAdStats;
